import React, { Component } from "react";
import { Link } from "react-router-dom";
import TimeDiff from "../helpers/TimeDiff";
import MinNav from "./component/MinNav";

class ReportTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reports: []
    };

    this.delete = this.delete.bind(this);
  }

  delete(e) {
    if (window.confirm("Are you sure you want to delete report?")) {
      let reportID = e.target.getAttribute("data-id");
      fetch(`${this.props.apiROOT}report/delete/${reportID}`)
        .then(res => res.json())
        .then(data => {
          if (data.status === true) {
            //eslint-disable-next-line
            this.state.reports.map((r, i) => {
              if (r.report_id === reportID) {
                delete this.state.reports[i];
              }
            });
            this.setState({ reports: this.state.reports });
          }
        });
    }
  }

  componentDidMount() {
    fetch(`${this.props.apiROOT}report/fetchAll`)
      .then(res => res.json())
      .then(data => {
        this.setState({
          reports: data.reports
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  render() {
    return (
      <div className="a-container">
        <MinNav />

        <table className="a-table">
          <thead>
            <tr>
              <td>Username</td>
              <td>Email</td>
              <td>Report</td>
              <td>Tag</td>
              <td>Post ID</td>
              <td>Time Posted</td>
              <td>Delete</td>
            </tr>
          </thead>
          <tbody>
            {this.state.reports.length > 0 &&
              this.state.reports.map(r => (
                <tr key={r.report_id}>
                  <td style={{ textAlign: "left" }}>
                    <Link
                      to={`/user/${r.username.replace(/ /g, "-")}-${r.user_id}`}
                    >
                      {r.username}{" "}
                    </Link>
                  </td>
                  <td style={{ textAlign: "left" }}>{r.email}</td>
                  <td style={{ textAlign: "left" }}>
                    {r.report.replace(/&#039;/g, "'")}
                  </td>
                  <td>{r.report_tag}</td>
                  <td>{r.post_id}</td>
                  <td>
                    <TimeDiff date={r.created_at} />{" "}
                  </td>
                  <td>
                    <button
                      className={`a-table-delete`}
                      data-id={r.report_id}
                      data-ban-status={r.ban_status}
                      onClick={this.delete}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default ReportTable;
